import { ThemeProvider as EmotionThemeProvider } from "@emotion/react";

export default function ThemeProvider({ theme, children }) {
  return <EmotionThemeProvider theme={theme}>{children}</EmotionThemeProvider>;
}
